import React from 'react';

const PrintAssetAlloc = ({ contentRef, formData, propertyList = [], tableData = [], allocations = {}, selectedRowIndex = -1 }) => {
    const getPropertyNameById = (id) => {
        const property = propertyList.find(p => p.Id === id);
        return property ? property.Name : 'Unknown Property';
    };

    // Use selected row if available, otherwise fallback to first row or empty object
    const itemRow = selectedRowIndex >= 0 && tableData[selectedRowIndex] ? tableData[selectedRowIndex] : tableData[0] || {};

    // Define data for the main formData table
    const rows = [
        [
            { label: 'Property', value: getPropertyNameById(formData.PropId) || 'Property Not Found' },
            { label: 'Custodian', value: formData.EmpName || 'N/A' },
        ],
        [
            { label: 'Alloc No', value: formData.AssetAllocNo || 'N/A' },
            { label: 'Alloc Date', value: formData.AssetAllocDt || 'N/A' },
        ],
        [
            { label: 'Barcode No', value: itemRow.BarcodeNo || formData.BarcodeNo || 'N/A' },
            { label: 'Item', value: itemRow.ItmName || formData.ItmName || 'N/A' },
        ],
        [
            { label: 'Vendor', value: itemRow.VendName || formData.VendName || 'N/A' },
            { label: 'Bill No', value: itemRow.BillNo || formData.BillNo || '0' },
        ],
        [
            { label: 'Brand', value: itemRow.ModelBrand || formData.ModelBrand || 'N/A' },
            { label: 'Item Category', value: itemRow.ItmCatName || 'N/A' },
        ],
        [
            { label: 'Item Group', value: itemRow.ItmGrpName || 'N/A' },
            { label: 'Item SubGroup', value: itemRow.ItmSubGrpName || 'N/A' },
        ],
        [
            { label: 'Qty', value: itemRow.Qty || formData.Qty || '0' },
            { label: 'Balance Qty', value: itemRow.BalQty || formData.BalQty || '0' },
        ],
    ];

    // Define columns for the tableData table
    const tableDataColumns = [
        { label: 'Sr.No', key: 'index' },
        { label: 'Item Name', key: 'ItmName' },
        { label: 'Quantity', key: 'Qty' },
        { label: 'Balance Quantity', key: 'BalQty' },
        { label: 'Rate', key: 'Rate' },
        { label: 'Vendor', key: 'VendName' },
        { label: 'Bill No', key: 'BillNo' },
        { label: 'Brand', key: 'ModelBrand' },
    ];

    // Define columns for the allocations table
    const allocationColumns = [
        { label: 'Sr.No', key: 'index' },
        { label: 'Type', key: 'type' },
        { label: 'Location Name', key: 'name' },
        { label: 'No of Locations', key: 'noOfLocation' },
        { label: 'Unit/Qty', key: 'perUnitQty' },
        { label: 'Total', key: 'total' },
        { label: 'Custodian', key: 'custodian' },
    ];

    // Process tableData to add index and filter out deleted rows
    const processedTableData = tableData
        .filter(row => row.DBFLAG !== 'D')
        .map((row, index) => ({
            ...row,
            index: index + 1,
        }));

    // Process allocations to create rows for printing
    const allocationRows = Object.entries(allocations)
        .filter(([_, alloc]) => alloc.selected?.length > 0)
        .flatMap(([type, alloc], typeIndex) =>
            alloc.selected.map((loc, locIndex) => ({
                index: typeIndex * alloc.selected.length + locIndex + 1,
                type,
                name: loc.Name || 'Unknown',
                noOfLocation: alloc.noOfLocation || '1',
                perUnitQty: alloc.perUnitQty || '0',
                total: (parseInt(alloc.perUnitQty || 0) * parseInt(alloc.noOfLocation || 1)).toString(),
                custodian: alloc.custodian || 'N/A',
            }))
        );

    return (
        <div
            ref={contentRef}
            style={{
                padding: '20px',
                maxWidth: '800px',
                margin: '0 auto',
                backgroundColor: 'white',
                fontFamily: 'Arial, sans-serif',
                position: 'relative',
            }}
        >
            {/* Header Section */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
                <img
                    src="https://www.clanbridge.com/wp-content/uploads/2024/12/IMGL6317.jpg.webp"
                    alt="Property Logo"
                    height={90}
                    width={90}
                    style={{ borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                />
                <span style={{ fontSize: '28px', color: '#635bff', fontWeight: 'bold' }}>
                    {getPropertyNameById(formData.PropId)}
                </span>
            </div>

            {/* Form Data Table */}
            <div style={{ marginBottom: '20px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#635bff' }}>
                            <th colSpan={4} style={{ fontSize: '20px', padding: '10px', border: '1px solid #e5e7eb', textAlign: 'left', color: 'white', fontWeight: 'bold' }}>
                                Asset Allocation Details
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rowIndex) => (
                            <tr key={rowIndex} style={{ fontSize: '16px', backgroundColor: rowIndex % 2 === 0 ? '#f9fafb' : '#ffffff' }}>
                                {row.map((cell, cellIndex) => (
                                    <React.Fragment key={cellIndex}>
                                        <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600', width: '25%' }}>
                                            {cell.label}
                                        </td>
                                        <td style={{ padding: '8px', border: '1px solid #e5e7eb', width: '25%' }}>
                                            {cell.value}
                                        </td>
                                    </React.Fragment>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Table Data Table */}
            {processedTableData.length > 0 && (
                <div style={{ marginBottom: '20px' }}>
                    <div
                        className="print-section-heading"
                        style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            color: '#635bff',
                            margin: '10px 0',
                        }}
                    >
                        Allocation Item
                    </div>
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#e5e7eb' }}>
                                {tableDataColumns.map((column) => (
                                    <th key={column.key} style={{ padding: '8px', border: '1px solid #e5e7eb', textAlign: 'left', fontWeight: '600' }}>
                                        {column.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {processedTableData.map((row, index) => (
                                <tr key={index} style={{ fontSize: '16px', backgroundColor: index % 2 === 0 ? '#f9fafb' : '#ffffff' }}>
                                    {tableDataColumns.map((column) => (
                                        <td key={column.key} style={{ padding: '8px', border: '1px solid #e5e7eb' }}>
                                            {row[column.key] || 'N/A'}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Allocations Table */}
            {allocationRows.length > 0 && (
                <div className="allocation-table" style={{ marginBottom: '20px' }}>
                    <style>
                        {`
                            @media print {
                                thead {
                                    display: table-header-group;
                                }

                                tfoot {
                                    display: table-footer-group;
                                }

                                tr {
                                    page-break-inside: avoid;
                                }

                                .print-section-heading {
                                    page-break-after: avoid;
                                }

                                .allocation-table {
                                    page-break-inside: auto;
                                }
                            }
                        `}
                    </style>

                    {/* Heading placed outside <table> */}
                    <div
                        className="print-section-heading"
                        style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            color: '#635bff',
                            margin: '10px 0',
                        }}
                    >
                        Allocation Details
                    </div>

                    {/* Table */}
                    <table
                        style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            border: '1px solid #e5e7eb',
                        }}
                    >
                        <thead>
                            <tr style={{ backgroundColor: '#e5e7eb' }}>
                                {allocationColumns.map((column) => (
                                    <th
                                        key={column.key}
                                        style={{
                                            padding: '8px',
                                            border: '1px solid #e5e7eb',
                                            textAlign: 'left',
                                            fontWeight: '600',
                                        }}
                                    >
                                        {column.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {allocationRows.map((row, index) => (
                                <tr
                                    key={index}
                                    style={{
                                        fontSize: '16px',
                                        backgroundColor: index % 2 === 0 ? '#f9fafb' : '#ffffff',
                                    }}
                                >
                                    {allocationColumns.map((column) => (
                                        <td
                                            key={column.key}
                                            style={{
                                                padding: '8px',
                                                border: '1px solid #e5e7eb',
                                            }}
                                        >
                                            {row[column.key] || 'N/A'}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default PrintAssetAlloc;